import { Link, useNavigate } from "react-router";
import useScreenDimensions from "../hooks/useScreenDimensions";
import { PricingOption } from "../components/pricingOption";
import { useEffect, useMemo, useState } from "react";
import { datasource } from "../datasource/datasource";
import { useAuth } from "@clerk/clerk-react";
import useOrganziations from "../hooks/useOrganizations";
import { isMobile } from "react-device-detect";
import { ToggleSwitch } from "../components/toggleswitch";
import * as motion from "motion/react-client";

const businessPlanFeatures = [
  "3 Campaign",
  "1 User",
  "30 Video Reviews Per Month",
  "Multi-Question Format",
  "4k Video Quality",
  "No Watermark",
  "Unlimited Downloads",
  "Unlimited Storage",
];

const unlimitedPlanFeatures = [
  "Unlimited Campaign",
  "Unlimited User",
  "Unlimited Video Reviews",
  "Generate Sharable Link",
  "Multi-Question Format",
  "4k Video Quality",
  "No Watermark",
  "Unlimited Downloads",
  "Unlimited Storage",
];

export const PlanChoicePage = () => {
  const { height, width } = useScreenDimensions();
  const setUserOrganizations = useOrganziations(
    (state) => state.setAllOrganizations
  );
  const [annual, setAnnual] = useState<boolean>(false);
  const toggleSwitchTitle = useMemo(
    () => `Billed ${annual ? "Annually (Get Two Months Free)" : "Monthly"}`,
    [annual]
  );
  const setActiveOrg = useOrganziations((state) => state.setActiveOrganization);

  const nav = useNavigate();

  const { getToken } = useAuth();
  useEffect(() => {
    getToken().then((token) =>
      datasource.getUserOrgs(token as string).then((userOrgs) => {
        if (!userOrgs.length) {
          nav("/auth/set-up");
          return;
        } else if (userOrgs[0].planTypeId !== 1) {
          nav("/auth/dashboard");
        }
        setUserOrganizations(userOrgs);
        setActiveOrg(userOrgs[0]);
      })
    );
  }, []);
  return (
    <div
      style={{
        minHeight: height,
        width,
        backgroundColor: "#F6F2EC",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          fontWeight: 600,
          fontSize: "2rem",
          marginBottom: "2rem",
          textAlign: "center",
          marginTop: isMobile ? "2rem" : 0,
        }}
      >
        Which Plan Is Best For You?
      </div>
      <ToggleSwitch
        title={toggleSwitchTitle}
        setIsOn={setAnnual}
        isOn={annual}
      />
      {annual ? (
        <motion.div
          style={{
            marginTop: "1rem",
            display: "flex",
            justifyContent: "center",
            gap: "6rem",
            width: "100%",
            flexDirection: isMobile ? "column" : "row",
            marginBottom: "6rem",
          }}
          key={"annual"}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.35, ease: "easeIn" }}
        >
          
          <PricingOption
            link="/auth/pricing/unlimited/annual"
            name="Unlimited Plan"
            price={`47`}
            features={unlimitedPlanFeatures}
            buttonColor="black"
            buttonTextColor="white"
            buttonShift={0}
          />
          <PricingOption
            link="/auth/pricing/business/annual"
            name="Business Plan"
            price={`35`}
            features={businessPlanFeatures}
            buttonColor="#BCBCBC"
            buttonTextColor="black"
            buttonShift={1.8}
          />
        </motion.div>
      ) : (
        <motion.div
          key={"monthly"}
          style={{
            marginTop: "1rem",
            display: "flex",
            justifyContent: "center",
            gap: "6rem",
            width: "100%",
            flexDirection: isMobile ? "column" : "row",
            marginBottom: "6rem",
          }}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.35, ease: "easeIn" }}
        >
          
          <PricingOption
            link="/auth/pricing/unlimited/month"
            name="Unlimited Plan"
            price={`57`}
            features={unlimitedPlanFeatures}
            buttonColor="black"
            buttonTextColor="white"
            buttonShift={0}
          />
          <PricingOption
            link="/auth/pricing/business/month"
            name="Business Plan"
            price={`43`}
            features={businessPlanFeatures}
            buttonColor="#BCBCBC"
            buttonTextColor="black"
            buttonShift={1.8}
          />
        </motion.div>
      )}
    </div>
  );
};
